/**
 * Turn a content-library partition / collection_name into a human path label.
 * Stored values use the literal token `FORWARDSLASH` instead of `/`.
 * @param partition - Raw partition / collection name from the API or source URL
 * @returns Display path with ` / ` separators, or an empty string
 */
export function formatPartitionLabel(partition: string | null | undefined): string {
  if (!partition) return "";
  return partition.split("FORWARDSLASH").join(" / ");
}
